"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.5 20.7",
    width: "24.5",
    height: "20.7"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,20.7H0.5c-0.2,0-0.3-0.1-0.4-0.3S0,20.1,0.1,20l3.4-5.8l0.9,0.5l-3,5h21.8L20.2,15l0.9-0.5l3.4,5.5 c0.1,0.2,0.1,0.3,0,0.5C24.4,20.6,24.2,20.7,24,20.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.2,3.3l-0.9-0.5l1.5-2.5c0.2-0.3,0.7-0.3,0.9,0l1.4,2.4l-0.9,0.5l-0.9-1.6L11.2,3.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#F8B133",
    d: "M12.3,19.4c-4.2,0-7.7-3.5-7.7-7.7C4.6,7.5,8,4,12.3,4S20,7.5,20,11.7C20,16,16.5,19.4,12.3,19.4z M12.3,5.5c-3.4,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2s6.2-2.8,6.2-6.2S15.7,5.5,12.3,5.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#F8B133",
    d: "M12.3,15.4c-2,0-3.7-1.7-3.7-3.7S10.2,8,12.3,8c2,0,3.7,1.7,3.7,3.7S14.3,15.4,12.3,15.4z M12.3,9 c-1.5,0-2.7,1.2-2.7,2.7s1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7S13.8,9,12.3,9z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "13.4",
    y: "14.5",
    fill: "#F8B133",
    width: "1",
    height: "4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10.2",
    y: "14.5",
    fill: "#F8B133",
    width: "1",
    height: "4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "6.3",
    y: "14.4",
    transform: "matrix(0.9138 -0.4061 0.4061 0.9138 -5.3455 4.6514)",
    fill: "#F8B133",
    width: "3.9",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "5.2",
    y: "11.4",
    transform: "matrix(0.9154 -0.4025 0.4025 0.9154 -4.1612 3.9245)",
    fill: "#F8B133",
    width: "4.1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "7.3",
    y: "7.4",
    transform: "matrix(0.7327 -0.6806 0.6806 0.7327 -4.277 7.8372)",
    fill: "#F8B133",
    width: "1",
    height: "3.9"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "9.6",
    y: "5.1",
    transform: "matrix(0.729 -0.6845 0.6845 0.729 -2.1337 8.8643)",
    fill: "#F8B133",
    width: "1",
    height: "4"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "15.7",
    y: "13",
    transform: "matrix(0.4062 -0.9138 0.9138 0.4062 -3.9851 23.7079)",
    fill: "#F8B133",
    width: "1",
    height: "3.9"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "16.8",
    y: "9.8",
    transform: "matrix(0.4025 -0.9154 0.9154 0.4025 -0.5362 22.9051)",
    fill: "#F8B133",
    width: "1",
    height: "4.1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "14.8",
    y: "8.9",
    transform: "matrix(0.6808 -0.7325 0.7325 0.6808 -1.528 15.2201)",
    fill: "#F8B133",
    width: "3.9",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12.4",
    y: "6.6",
    transform: "matrix(0.6848 -0.7287 0.7287 0.6848 -0.6519 12.7463)",
    fill: "#F8B133",
    width: "4",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#F8B133",
    d: "M12.3,13.3c-0.9,0-1.6-0.7-1.6-1.6s0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6S13.1,13.3,12.3,13.3z M12.3,11.2c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6c0.3,0,0.6-0.3,0.6-0.6S12.6,11.2,12.3,11.2z"
  }));
};

exports["default"] = _default;